
            const data = {"name":"clock","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M30 59a29 29 0 1129-29 29 29 0 01-29 29zm0-52.73A23.73 23.73 0 1053.74 30 23.73 23.73 0 0030 6.27zM30.65 34H17.94a2.52 2.52 0 010-5h10.2V14.75a2.52 2.52 0 115 0v16.68A2.52 2.52 0 0130.66 34z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                